import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import styled from "styled-components";
import { colorBackgroundBody } from "@/utils/palette";
import { paddingLeft } from "@/utils/directions";
import Layout from "../../../Layout/index";

import Dashboard from "../../../../components/Dashboard/index";
// DASHBOARD V2 BLOCK 2/3 — comment out before pushing to production
import DashboardV2 from "../../../../components/DashboardV2/index";
// END DASHBOARD V2 BLOCK 2/3
import UserManagement from "../../../../components/UserManagement/index";
import Assets from "../../../../components/Assets/index";
import DailyTimeSheet from "../../../../components/DailyTimeSheet/index";
import DailyMileage from "../../../../components/DailyMileage/index";
import FillUps from "../../../../components/FillUps/index";
import Services from "../../../../components/Services/index";
import OtherExpenses from "../../../../components/OtherExpenses/index";
import Trips from "../../../../components/Trips/index";
import Billing from "../../../../components/Billing/index";
import VehicleInspection from "../../../../components/VehicleInspection";
import Settings from "../../../../components/Settings";
import Reminders from "../../../../components/Reminders";
import RenewalsForm from "../../../../components/Reminders/Renewals/RenewalsForm";
import MaintenanceRemindersForm from "../../../../components/Reminders/MaintenanceReminders/MaintenanceRemindersForm";
import Issues from "../../../../components/Issues";
import { createContext } from "react";
import { useState } from "react";
import WorkOrders from "../../../../components/WorkOrders";
import { useAuth } from "../../../../contexts/AuthContext";
import { auth } from "../../../../api/firebase";
import { UserNameProvider } from "../../../../contexts/UserNameContext";
import { useLocation } from "react-router";
import InfoPopup from "../../../../shared/components/InfoPopup";
import { Trans, useTranslation } from "react-i18next";
import { colorBlue } from "../../../../utils/palette";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import { postApi } from "../../../../api/getUser";
import RatingPopup from "../../../../shared/components/RatingPopup";
//import WishPopup from "../../../../shared/components/WishPopup";
import { useSelector } from "react-redux";
import FaultCodes from "../../../../components/FaultCodes";
import Inventory from "../../../../components/Inventory";
import Reporting from "../../../../components/Reporting";
import WriteRoute from "../../../../shared/components/WriteRoute";

// export const DeletedContext = createContext(null);
export default () => {
  //const [deleted, setDeleted] = useState(false);
  //const toggleDeleted = () => setDeleted((prev) => !prev);
  //const [reload, setReload] = useState(false);
  //const toggleReload = () => setReload((prev) => !prev);
  //const [loading, setLoading] = useState(false);
  //const setLoadingToTrue = () => setLoading(true);
  //const setLoadingToFalse = () => setLoading(false);

  const {
    isLoggedIn,
    dummyRecordsPopup,
    setDummyRecordsPopup,
    tag,
    showRatingPopup,
    showWishPopup,
    showErrPopup,
    setShowErrPopup,
    isPaymentOverdue,
    isFreePlan,
  } = useAuth();
  const { pathname } = useLocation();
  const { t } = useTranslation("common");
  const { status } = useSelector((state) => state.filter);

  //Effect to show global api error popup if status fails
  useEffect(() => {
    if (status === "failed") {
      setShowErrPopup(true);
    }
  }, [status]);

  useEffect(() => {
    if (
      !dummyRecordsPopup.show &&
      dummyRecordsPopup.signUp &&
      !pathname.includes("users/addnew")
    ) {
      setDummyRecordsPopup({ show: true, signUp: true });
    }
  }, [pathname]);

  const HelmetComp = ({ tag }) => {
    return (
      <div>
        {tag ? (
          <Helmet>
            <script>
              {`window.fcWidgetMessengerConfig = {
                tags: ["${tag}"],
              }`}
            </script>
            <script
              src="//fw-cdn.com/2480920/3044936.js"
              id="freshChat"
              chat="true"
            ></script>
          </Helmet>
        ) : (
          <Helmet></Helmet>
        )}
      </div>
    );
  };

  const redirect = () => {
    const logout = localStorage.getItem("logout");
    if (logout === "true") {
      return <Redirect push state={logout === "true"} to="/404" />;
    }
  };

  return (
    <>
      {redirect()}
      {isLoggedIn && (
        <>
          {showRatingPopup && <RatingPopup />}
          {/* {showWishPopup && !showRatingPopup && <WishPopup />} */}

          {/* {showErrPopup && (
            <InfoPopup
              showPopup={showErrPopup}
              setShowPopup={setShowErrPopup}
              message={t("listing_err_msg")}
              icon={{ className: "fi fi-rr-triangle-warning", color: "red" }}
              actionIcon={{
                handler: () => {
                  location.reload();
                },
                label: t("refresh"),
              }}
              onClose={() => location.reload()}
            />
          )} */}
          <UserNameProvider>
            {tag && <HelmetComp tag={tag} />}
            {/* {tag && loadScripts()} */}
            <div>
              {dummyRecordsPopup.show && (
                <InfoPopup
                  message={
                    <Trans i18nKey="dummy_records_message" t={t}></Trans>
                  }
                  showPopup={dummyRecordsPopup.show}
                  setShowPopup={() =>
                    setDummyRecordsPopup({ show: false, signUp: false })
                  }
                  icon={{
                    className: "fi fi-rr-truck-moving",
                    color: colorBlue,
                  }}
                  actionIcon={{
                    label: t("okay"),
                    handler: () =>
                      setDummyRecordsPopup({ show: false, signUp: false }),
                  }}
                />
              )}
              <Layout />
              {/* <Layout /> */}
              {/* <DeletedContext.Provider
                value={{
                  deleted,
                  toggleDeleted,
                  reload,
                  toggleReload,
                  loading,
                  setLoadingToFalse,
                  setLoadingToTrue,
                }}
              > */}
              <ContainerWrap $isBannerVisible={isPaymentOverdue || isFreePlan}>
                {/* <Route path="/dashboard" component={Dashboard} /> */}
                <Route path="/dashboard" component={DashboardV2} />
                {/* DASHBOARD V2 BLOCK 3/3 — legacy alias, safe to remove later */}
                {/* <Route path="/dashboard-v2" component={DashboardV2} /> */}
                {/* END DASHBOARD V2 BLOCK 3/3 */}
                <Route path="/reporting" component={Reporting} />
                <Route path="/users" component={UserManagement} />
                <Route path="/assets" component={Assets} />
                <Route path="/dailytimesheet" component={DailyTimeSheet} />
                <Route path="/dailymileage" component={DailyMileage} />
                <Route path="/fillups" component={FillUps} />
                <Route path="/services" component={Services} />
                <Route path="/expenses" component={OtherExpenses} />
                <Route path="/reminders" component={Reminders} />
                <Route path="/trips" component={Trips} />
                <Route path="/inspection" component={VehicleInspection} />
                <WriteRoute
                  path="/billing"
                  component={Billing}
                  redirectTo="/dashboard"
                />
                <WriteRoute
                  path="/setup"
                  component={Settings}
                  redirectTo="/dashboard"
                />
                <Route path="/faultcodes" component={FaultCodes} />
                {/* <Route path="/faq" component={FAQ} />
                <Route path="/demo" component={DemoVideo} />
                <Route path="/feedback" component={Feedback} />
                <Route path="/support" component={ContactSupport} /> */}
                {/* <Route path="/account" component={Account} /> */}
                <WriteRoute
                  path="/addmaintenancereminder"
                  component={MaintenanceRemindersForm}
                  redirectTo="/reminders/maintenancereminders"
                />
                <WriteRoute
                  path="/addrenewal"
                  component={RenewalsForm}
                  redirectTo="/reminders/renewals"
                />
                <Route path="/issues" component={Issues} />
                <Route path="/workorders" component={WorkOrders} />
                <Route path="/inventory" component={Inventory} />

                {/* <Route exact path="/issues" component={IssuesTable} /> */}
                {/* <Route exact path="/issues/addnew" component={IssuesForm} /> */}
                {/* <Route path="/addinspectiontask" component={InspectionTasksForm} /> */}
                {/* <Route path="/addinspectionform" component={InspectionFormsForm} /> */}
              </ContainerWrap>
              {/* </DeletedContext.Provider> */}
            </div>
          </UserNameProvider>
        </>
      )}
    </>
  );
};

// region STYLES

const ContainerWrap = styled.div`
  padding-top: ${(p) =>
    p.$isBannerVisible ? "115px" : "75px"}; //Changed from 85 to 75
  height: 100%;
  transition: padding-left 0.3s;

  ${paddingLeft}: 0;

  background: ${colorBackgroundBody};

  @media screen and (min-width: 800px) {
    ${paddingLeft}: 250px;
  }

  @media screen and (max-width: 800px) {
    padding-top: 150px;
  }
`;

// endregion
